import * as React from "react";

interface VacuumTableHeaderUIProps {
  // style: React.CSSProperties;
}

export class VacuumTableHeaderUI extends React.PureComponent<
  VacuumTableHeaderUIProps,
  {}
> {
  render() {
    let tableHeaderClassNames = "table-header";

    let fullRow = (
      <div className={tableHeaderClassNames}>
        <div className="category-col">Category</div>

        <div className="cm-col">CM Title</div>
        <div className="ams-col">AMS</div>
        <div className="pwa-col">PWA</div>
        <div className="ge-col">GE</div>
        <div className="rrp-col">RRP - MSRR</div>
        <div className="rrc-col">RRC - EMS</div>
        <div className="honeywell-col">H - EMS</div>
        <div className="safran-col">S - DMD</div>

        {/* Carbon */}
        <div className="table-elemental-col">C</div>
        {/* Cobalt */}
        <div className="table-elemental-col">Co</div>
        {/* Chromium */}
        <div className="table-elemental-col">Cr</div>
        {/* Tungsten */}
        <div className="table-elemental-col">W</div>
        {/* Niobium */}
        <div className="table-elemental-col">Nb</div>
        {/* Tantalum */}
        <div className="table-elemental-col">Ta</div>
        {/* Titanium */}
        <div className="table-elemental-col">Ti</div>
        {/* Aluminum */}
        <div className="table-elemental-col">Al</div>
        {/* Boron */}
        <div className="table-elemental-col">B</div>
        {/* Zirconium */}
        <div className="table-elemental-col">Zr</div>
        {/* Hafnium */}
        <div className="table-elemental-col">Hf</div>
        {/* Iron */}
        <div className="table-elemental-col">Fe</div>
        {/* Rhenium */}
        <div className="table-elemental-col">Re</div>
        <div className="density-metric-col">
          <span>
            &#961; (gm/cm<sup>3</sup>)
          </span>
        </div>
        <div className="imperial-metric-col">
          <span>
            &#961; (lb/in<sup>3</sup>)
          </span>
        </div>
        <div className="physical-col">
          <span>
            T<sub>S</sub> (&#176;F)
          </span>
        </div>
        <div className="physical-col">
          <span>
            T<sub>L</sub> (&#176;F)
          </span>
        </div>
        <div className="physical-col">
          <span>
            T<sub>S</sub> (&#176;C)
          </span>
        </div>
        <div className="physical-col">
          <span>
            T<sub>L</sub> (&#176;C)
          </span>
        </div>
        <div className="other-col">Other</div>
      </div>
    );

    return fullRow;
  }
}
